import React, { useState } from 'react';
import { Box, TextField, Button, Grid, Typography, Container, Paper, CircularProgress} from '@mui/material';
import emailjs from 'emailjs-com';
import Snack from './Snack'
import axios from "axios";
import MenuItem from '@mui/material/MenuItem';



const AmbassadorForm = () => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');


  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    region: '',
    district: '',
    ward: '',
    street: '',
    businessName: '',
    category: '',
  });


  const [loading, setLoading] = useState(false); // Loading state


  






  const categories = [
  
    {
      value: 'company',
      label: 'company',
    },
    {
      value: 'vicoba',
      label: 'vicoba',
    },
    {
      value: 'sole proprietary',
      label: 'sole proprietary',
    },
    {
      value: 'saccoss',
      label: 'saccoss',
    }
  ];

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const snackbar=()=>{
    return(
      console.log('snackbar reached')
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true
    console.log("form data", formData)

    try {
      const response = await axios.post("https://sava-api.tbridge.africa/health/receive-ambassador-application", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
  
  snackbar();

  setSnackbarMessage('Email sent successfully!');
  setShowSnackbar(true);
  setLoading(false); // Reset loading state

// Reset the form data
setFormData({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  region: '',
  district: '',
  ward: '',
  street: '',
  businessName: '',
  category: '',
});

      } else {
        alert("Error submitting form!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  }; 


/* const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true

    emailjs
      .send(
        'service_tis733l', // Your service ID
        'template_i9ol0aj', // Your template ID
        formData,           // Form data to be sent
        'IYV_6LZ__faZWczV4' // Your public key
      )
      .then(
        (response) => {
          console.log('Email sent successfully:', response);
          snackbar();

          setSnackbarMessage('Email sent successfully!');
          setShowSnackbar(true);
          setLoading(false); // Reset loading state


// Reset the form data
setFormData({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  region: '',
  district: '',
  ward: '',
  street: '',
  businessName: '',
  category: '',
});



        },
        (error) => {
          console.error('Error sending email:', error);
          alert('Error submitting form!');
        }
      );
  }; */

  return (
    <Container sx={{ marginTop: { xs: '10px', sm: '10px' }, marginBottom: { xs: '0px' } }}>
      <Paper
        sx={{
          maxWidth: { xs: '100%', sm: '800px' },
          backgroundColor: 'white',
          margin: { xs: '0px', sm: 'auto' },
          padding: '10px',
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              marginBottom: '20px',
              color: 'black',
              fontWeight: 'bold',
            }}
          >
            Ambassador Application Form
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {/* Row 1 */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="First Name"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="Last Name"
                  variant="outlined"
                  size="small"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>

              {/* Row 2 */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  required
                  label="Email Address"
                  variant="outlined"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  placeholder="+255 785 907 500"
                  fullWidth
                  required
                  label="Phone Number"
                  variant="outlined"
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: 'black',
                    },
                  }}
                />
              </Grid>

              {/* Row 3 */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="Region"
                  variant="outlined"
                  name="region"
                  value={formData.region}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="District"
                  variant="outlined"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>

              {/* Row 4 */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="Ward"
                  variant="outlined"
                  name="ward"
                  value={formData.ward}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Street"
                  variant="outlined"
                  required
                  name="street"
                  value={formData.street}
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#ccc',
                      },
                      '&:hover fieldset': {
                        borderColor: '#000',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#000',
                      },
                      "& .MuiInputBase-input": {
      color: "black", // Make entered text black
    },
                    },
                  }}
                />
              </Grid>

              {/* Row 5 */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="Name of Business/ Group/ Company"
                  
                  variant="outlined"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#ccc" },
                      "&:hover fieldset": { borderColor: "#000" },
                      "&.Mui-focused fieldset": { borderColor: "#000" },
                    },
                    "& .MuiInputBase-input": {
                      color: "black", // Make entered text black
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
              <TextField
                  fullWidth
                  size="small"
                  label="Select Category"
                  variant="outlined"
                  select
                  required
                  
                  name="category"
                placeholder="testing"
                  value={formData.category}
                  defaultValue="company"
                  onChange={handleChange}
                  // InputLabelProps={{
                  //   shrink: true, // Ensures label stays at the top-left
                  // }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#ccc" },
                      "&:hover fieldset": { borderColor: "#000" },
                      "&.Mui-focused fieldset": { borderColor: "#000" },
                    },
                    "& .MuiInputBase-input": {
                      color: "black", // Make entered text black
                    },
                    "& .MuiInputBase-input::placeholder": {
      color: "red", // Set placeholder text color to red
      opacity:1
    },
                  }}
               
                >
          {/* <MenuItem value="" disabled  sx={{color:'red', backgroundColor: 'red'}}>
                  Select Category
                </MenuItem> */}


                  {categories.map((option) => (
                    <MenuItem key={option.value} value={option.value}  sx={{color:'black', backgroundColor: 'white'}}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                  disabled={loading} // Disable button while loading
                 endIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner if loading
                >
                  {loading ? 'Loading...' : 'Submit'}
                </Button>

              {showSnackbar && (
         <Snack open={showSnackbar} handleClose={handleCloseSnackbar} />
      )}
            </Box>
          </form>
        </Box>
      </Paper>

   


      
    </Container>
  );
};

export default AmbassadorForm;
